import { c as _c } from "react/compiler-runtime";
import { Controller, UseFormReturn } from "react-hook-form";
import FormPartTitle from "@/components/form/form-part-title";
import { FormSelect } from "@/components/global/form/inputs/form-select";
import { MemberRead, TestimonyRead } from "@/TS/Interfaces/global_interfaces";
import { SendTestimonyFormValues } from "../schemas/schema";
export const MembersSection = t0 => {
  const $ = _c(10);
  const {
    methods,
    members,
    toBeUpdated,
    testimony
  } = t0;
  const {
    formState: t1
  } = methods;
  const {
    errors,
    isSubmitted
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FormPartTitle className="mb-[1.25rem]" classNameTitle="!text-base tracking-[.8px]">TÉMOIN</FormPartTitle>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== errors.witness || $[2] !== isSubmitted || $[3] !== members || $[4] !== testimony?.witness || $[5] !== toBeUpdated) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormSelect {...field} label="Membre" placeholder={"S\xE9lectionner un membre..."} error={errors.witness?.message} isValid={isSubmitted && !errors.witness} disabled={toBeUpdated} styles={{
        layout: {
          className: "mb-[1.25rem]"
        }
      }}>{toBeUpdated ? <option value={testimony?.witness.id}>{testimony?.witness.fullName}</option> : Array.isArray(members) && members.map(_temp)}</FormSelect>;
    };
    $[1] = errors.witness;
    $[2] = isSubmitted;
    $[3] = members;
    $[4] = testimony?.witness;
    $[5] = toBeUpdated;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== methods.control || $[8] !== t3) {
    t4 = <>{t2}<Controller control={methods.control} name="witness" render={t3} /></>;
    $[7] = methods.control;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(member) {
  return <option key={member.id} value={member.id}>{member.firstName} {member.lastName}</option>;
}